import React from 'react';
import { Offer } from '../types';
import { ArrowLeft, Star, ExternalLink, ShoppingBag } from 'lucide-react';
import { Link } from 'react-router-dom';
interface BrandHeroProps {
  offer: Offer;
}
export function BrandHero({
  offer
}: BrandHeroProps) {
  return <div className="bg-gradient-to-br from-kithward-700 to-kithward-800 text-white pt-8 pb-12 px-4 md:px-8" data-id="element-36">
      <div className="max-w-7xl mx-auto" data-id="element-37">
        {/* Back Button */}
        <Link to="/explore" className="inline-flex items-center text-white/80 hover:text-white mb-8 transition-colors font-medium" data-id="element-38">
          <ArrowLeft className="w-5 h-5 mr-2" data-id="element-39" />
          Back to Explore
        </Link>

        <div className="flex flex-col md:flex-row items-center md:items-start gap-8" data-id="element-40">
          {/* Logo Placeholder */}
          <div className="w-24 h-24 md:w-32 md:h-32 bg-white rounded-2xl shadow-lg flex items-center justify-center text-kithward-700 font-bold text-xl flex-shrink-0" data-id="element-41">
            {offer.merchant.charAt(0)}
          </div>

          <div className="flex-1 text-center md:text-left" data-id="element-42">
            <h1 className="text-4xl md:text-5xl font-serif font-bold mb-3" data-id="element-43">
              {offer.merchant}
            </h1>

            {/* Rating */}
            <div className="flex items-center justify-center md:justify-start gap-2 mb-6" data-id="element-44">
              <div className="flex text-amber-400" data-id="element-45">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-46" />)}
              </div>
              <span className="text-lg font-medium" data-id="element-47">
                {offer.rating || '4.8'} ({offer.reviewCount || '1.2k'} reviews)
              </span>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start" data-id="element-48">
              <button className="bg-white text-kithward-700 px-8 py-3.5 rounded-full font-bold text-lg shadow-lg hover:bg-gray-50 hover:shadow-xl transition-all flex items-center justify-center gap-2" data-id="element-49">
                <ShoppingBag className="w-5 h-5" data-id="element-50" />
                Shop Now & Earn
              </button>
              <button className="border-2 border-white/30 text-white px-8 py-3.5 rounded-full font-bold text-lg hover:bg-white/10 transition-all flex items-center justify-center gap-2" data-id="element-51">
                <ExternalLink className="w-5 h-5" data-id="element-52" />
                Visit Store
              </button>
            </div>
          </div>

          {/* Cashback Badge */}
          <div className="bg-green-500 text-white px-8 py-6 rounded-2xl shadow-xl transform rotate-2 hover:rotate-0 transition-transform duration-300 text-center min-w-[200px]" data-id="element-53">
            <p className="text-sm font-bold uppercase tracking-wider mb-1 opacity-90" data-id="element-54">
              Earn
            </p>
            <p className="text-5xl font-bold mb-1" data-id="element-55">{offer.cashbackPercent}%</p>
            <p className="text-lg font-bold" data-id="element-56">Cash Back</p>
          </div>
        </div>
      </div>
    </div>;
}